// Frontend style polyfills
import './polyfills.scss';

// Framework
import './_framework.scss'

// Frontend scss
import './frontend.scss';

// Import assets
import './assets/generatedAssets.js';